import React from 'react';
import classNames from 'classnames';
import bowser from 'yola-bowser';
import Icon from '../icon';
// eslint-disable-next-line yola/@typescript-eslint/no-unused-vars
import { iconsList } from '../icon/glyphs';
import Tooltip from '../tooltip/index';

// @ts-ignore TS(2322): Type 'null' is not assignable to type 'string'.
function Breadcrumbs({
  captions,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type 'string'.
  className = null,
  active = false,
  // @ts-ignore TS(2322): Type 'null' is not assignable to type '(...args: any[]) => any'.
  onClick = null,
  icon = null,
  translate = null,
}) {
  const isMobile = bowser.mobile || bowser.tablet;
  const breadcrumbsClass = classNames('ws-breadcrumbs', className, {
    'ws-breadcrumbs--active': active,
    'ws-breadcrumbs--mobile': isMobile,
    'ws-breadcrumbs--with-icon': icon,
    'ws-breadcrumbs--inactive': !onClick,
  });

  return (
    // @ts-ignore TS(2322): Type 'null' is not assignable to type 'string'.
    <ul className={breadcrumbsClass} onClick={onClick} {...(translate && { translate })}>
      <li className="ws-breadcrumbs__crumb">{captions.pages}</li>
      <li className="ws-breadcrumbs__crumb">{captions.pageName}</li>
      {icon && (
        <React.Fragment>
          <Icon
            // @ts-ignore TS(2322): Type '{ className: string; glyph: any; onClick: ((... Remove this comment to see the full error message
            className="ws-breadcrumbs__icon"
            glyph={icon.type}
            onClick={icon.action}
            data-place="bottom"
            data-tip={icon.title}
          />
          {!isMobile && <Tooltip />}
        </React.Fragment>
      )}
    </ul>
  );
}

export default Breadcrumbs;
